import { Link } from "react-router-dom";
import { stats } from "@/mocks/data";

export default function CTA() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20and%20dark%20abstract%20technology%20background%20with%20smooth%20flowing%20gradients%2C%20luxurious%20atmosphere%2C%20minimalist%20design%2C%20soft%20light%20effects%2C%20premium%20quality%2C%20elegant%20composition%2C%20no%20text%2C%20dark%20and%20warm%20tones&width=1600&height=500&seq=cta-bg-v2&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-50/70">{stat.label}</div>
            </div>
          ))}
        </div>
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
            立即体验9170手机版
          </h2>
          <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto mb-8">
            随时随地，一键登录。iOS与Android全面支持，安全稳定，畅享完整服务体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/usage-guide"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200"
            >
              <i className="ri-smartphone-line"></i>
              进入手机版指南
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 px-8 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200 backdrop-blur-sm"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}